import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout.vue';

/**
 * 出价-模块
 */
var bid = {
  path: '/bid',
  component: RootLayout,
  redirect: '/bid',
  children: [{
    path: '/bid',
    name: 'Bid',
    component: function component() {
      return import('views/bid/index.vue');
    },
    meta: {
      title: '出价'
    }
  }, {
    path: '/bid/receive',
    name: 'BidReceive',
    component: function component() {
      return import('views/bid/receive.vue');
    },
    meta: {
      title: '接受出价'
    }
  }, {
    path: '/bid/receive/order/result',
    name: 'BidReceiveOrderResult',
    component: function component() {
      return import('views/bid/receiveOrderResult.vue');
    },
    meta: {
      title: '交易结果'
    }
  }, {
    path: '/bid/sms',
    name: 'SmsCodeAuth',
    component: function component() {
      return import('views/bid/smsCodeAuth.vue');
    },
    meta: {
      title: '身份验证'
    }
  }, {
    path: '/bid/check',
    name: 'DigitalCheck',
    component: function component() {
      return import('views/bid/check.vue');
    },
    meta: {
      title: '出价'
    }
  }, {
    path: '/bid/pay/order',
    name: 'BidPayOrder',
    component: function component() {
      return import('views/bid/payOrder.vue');
    },
    meta: {
      title: '确认订单'
    }
  }, {
    path: '/bid/record',
    name: 'BidRecord',
    component: function component() {
      return import('views/bid/record.vue');
    },
    meta: {
      title: '出价记录'
    }
  }, {
    path: '/bid/transactionRecord',
    name: 'BidTransactionRecord',
    component: function component() {
      return import('views/bid/transactionRecord.vue');
    },
    meta: {
      title: '成交记录'
    }
  }]
};
export default bid;